var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const React = require('react');
const Icon = require('@infotech/uikit-icon').default;

function Svg(props) {
  const svgProps = Object.assign({}, props);
  const title = props.title;
  delete props.title;

  /* <svg {...svgProps} ><title>{title}<title>...</svg> */
  return React.createElement(
    'svg',
    _extends({ width: '24', height: '24', viewBox: '0 0 24 24', focusable: 'false' }, svgProps, { 'aria-labelledby': 'title' }),
    React.createElement(
      'title',
      { id: 'title' },
      title
    ),
    React.createElement('path', { d: 'M13.656 12.242l3.536-3.536a1 1 0 00-1.414-1.413l-3.536 3.535-3.536-3.535a1 1 0 00-1.413 1.413l3.535 3.537-3.535 3.535a1 1 0 001.413 1.414l3.537-3.536 3.535 3.536a.997.997 0 001.414 0 1 1 0 000-1.414l-3.536-3.536z', fillRule: 'evenodd', role: 'presentation' })
  );
}

module.exports = function close(props) {
  return React.createElement(Icon, _extends({ glyph: Svg }, props));
};